export const ENABLED_FILTERS = [
    {label: 'Yes', value: 'Yes'},
    {label: 'No', value: 'No'},
];